import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import TextInput from "components/TextInput";
import SimpleSelect from "components/SimpleSelect";
import { BPEStore } from "features/BuildingProductEditor/ProductEditorStore";
import { COEStore } from "../ComponentEditorStore";

const GeneralInformation = () => {
  const { t } = useTranslation();

  return (
    <div className="pb-6 border-b border-gray-200">
      <div className="text-base font-semibold mb-3">
        {t("productEditor.generalInformation")}
      </div>
      <TextInput
        name="name"
        labelName={t("productEditor.name")}
        placeholder={t("productEditor.enterName")}
        handleChange={(value: string | undefined, name?: string) =>
          COEStore.onChangeData(name as string, value)
        }
        value={COEStore.data.name}
        required
      />
      <div className="mt-3">
        <SimpleSelect
          options={BPEStore.optionsLists.din_category as []}
          placeholder={t("productEditor.chooseCategory")}
          labelName={t("productEditor.din_category")}
          name="din_category"
          onChange={(value, name) =>
            COEStore.onChangeData(name as string, value)
          }
          current={COEStore.data.din_category}
          displayKey="name"
          containerClassName="w-full"
          noMargin
        />
      </div>
    </div>
  );
};

export default observer(GeneralInformation);
